import { useLocalSearchParams, useRouter } from 'expo-router';
import { ScrollView, Text, View } from 'react-native';

import { DatabaseTable } from '@/components/databases/DatabaseTable.web';

export default function DatabaseScreen() {
  const router = useRouter();
  const { id } = useLocalSearchParams<{ id: string }>();
  const databaseId = typeof id === 'string' ? id : id?.[0];

  if (!databaseId) {
    return (
      <View className="flex-1 items-center justify-center px-6">
        <Text className="text-base text-fg-muted">Missing database id</Text>
      </View>
    );
  }

  return (
    <ScrollView
      className="flex-1 bg-surface"
      contentContainerClassName="min-w-0 grow"
      showsVerticalScrollIndicator
    >
      <View className="cs-db-page min-w-0 w-full max-w-full px-page py-page-y">
        <DatabaseTable
          databaseId={databaseId}
          onOpenRow={(rowId) => router.push(`/page/${rowId}`)}
        />
      </View>
    </ScrollView>
  );
}
